export class Option {

    name = "";
    correct = false;

    constructor(name, correct) {
        this.name = name
        this.correct = correct
    }

}